import { Icon } from '@/components';
import { jsx as _jsx } from "react/jsx-runtime";
const Close = ({
  onClose
}) => {
  return /*#__PURE__*/_jsx("button", {
    type: "button",
    onClick: () => onClose(),
    className: "ima-close",
    children: /*#__PURE__*/_jsx(Icon, {
      icon: "cross",
      size: "lg"
    })
  });
};
export default Close;